import ErrorMessage from "legacy/ErrorMessage"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import { dollarsToCents, handleInputChange } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class AddAdjustmentFeesModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
      category: "adjustment",
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.save = this.save.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.validator = validatorFactory()
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  save() {
    if (this.validator.allValid()) {
      this.setState({ saving: true })
      const params = {
        category: this.state.category,
        description: this.state.description,
        amount: dollarsToCents(this.state.amount),
      }

      $.post(this.props.endpoint, params, () => {
        location.reload()
      }).fail((data) => {
        this.setState({
          errorMessage: "Error creating adjustment fee.",
          saving: false,
        })
      })
    } else {
      this.validator.showMessages()
      this.forceUpdate()
    }
  }

  render() {
    return (
      <div>
        <LegacyButton
          type="primary"
          className="hidden-print"
          onClick={this.openModal}
        >
          Add Adjustment Fee
        </LegacyButton>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="mediumFixed"
        >
          <Modal.Header title="Add Adjustment Fee" />
          <Modal.Body>
            <div className="">
              Adjustment fees are typically added when a{" "}
              {`${this.props.resourceName}`} is canceled or shortened to retain
              deposits and will affect the final price accordingly.
            </div>
            <hr />
            <div className="row nested-row">
              <div className="col-xs-6">
                <FormGroup
                  inputType="currency"
                  label="Amount"
                  name="amount"
                  value={this.state.amount}
                  onChange={this.handleInputChange}
                  validation={this.validator.message(
                    "amount",
                    this.state.amount,
                    "required|currency"
                  )}
                />
              </div>
              <div className="col-xs-6">
                <FormGroup
                  label="Description"
                  name="description"
                  value={this.state.description}
                  onChange={this.handleInputChange}
                  validation={this.validator.message(
                    "fee description",
                    this.state.description,
                    "required"
                  )}
                />
              </div>
            </div>
            <ErrorMessage>{this.state.errorMessage}</ErrorMessage>
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText="Apply Fee"
            confirmBtnLoading={this.state.saving}
            onClose={this.closeModal}
            onSubmit={this.save}
          />
        </Modal>
      </div>
    )
  }
}

AddAdjustmentFeesModal.propTypes = {
  resourceName: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
}

export default AddAdjustmentFeesModal
